import { useAuthUserDetails } from "@apis/users/useUsers"
import { useGetWinbackOffersQuery } from "@apis/winbacks/useWinbacks"
import { useGetRetentionOffersQuery } from "@apis/retention/useRetention"
import { OFFER_TYPES } from "@apis/offers/types"

import { useAccountOfferFunnel } from "./useAccountOfferFunnel"

export const useOffersSerializer = () => {
  const { data: userInfo } = useAuthUserDetails()
  const { eligibleOfferType, account_id } = useAccountOfferFunnel()

  const getWinbackOffersQuery = useGetWinbackOffersQuery(
    account_id,
    {
      user_id: userInfo?.user_id,
    },
    eligibleOfferType === OFFER_TYPES.Winback,
  )

  const getRetentionOffersQuery = useGetRetentionOffersQuery(
    account_id,
    {
      user_id: userInfo?.user_id,
    },
    eligibleOfferType === OFFER_TYPES.Retention,
  )

  return eligibleOfferType === OFFER_TYPES.Retention
    ? getRetentionOffersQuery
    : getWinbackOffersQuery
}
